import { SagaMiddleware } from "redux-saga";

import { userSagas } from "../user";
import { navigationSagas } from "../home";
import { adminSagas } from "../admin";

export function startSagas(sagaMiddleware: SagaMiddleware<any>) {
  const rootSagas = [navigationSagas, userSagas, adminSagas];

  for (const saga of rootSagas) {
    sagaMiddleware.run(saga as any);
  }
}
